import React from "react";
import Navbar from "../components/Navbar";
import CookiesPolicy from "../components/CookiesPolicy";
import Footer from "../components/Footer";
import SecondaryHero from "../components/SecondaryHero";
import { Helmet } from "react-helmet-async";

const Cookies = () => {
  return (
    <>
      {/* ✅ SEO + Tab Title */}
      <Helmet>
        <title>Cookies Policy | VisionBird Technologies</title>
        <meta
          name="description"
          content="Read the Cookies Policy of VisionBird Technologies to understand how we use cookies and protect user privacy on our website."
        />
      </Helmet>

      <Navbar />
      <SecondaryHero
        title="Cookies"
        highlight="Policy"
        description="(VisionBird Technologies, (“VisionBird Technologies”, “VBT”, “we”, “us”, 
                    “our” or the “Company”) is committed to protecting the privacy of 
                      individuals who visit the Company's web sites, individuals who 
                      register to use our services)"
        image="/assets/Images/Mobile encryption-bro 1.png"
      />
      <CookiesPolicy />
      <Footer />
    </>
  );
};

export default Cookies;